import React, {useEffect} from 'react';
import {MainTop} from "../groups/group-container/main-top/Main-top";
import {ReactComponent as BackIcon} from '../../../assets/main/groups/main-top/back.svg';
import {PaymentTable} from "./payment-table/Payment-table";
import {ActsTable} from "./acts-table/Acts-table";
import {useAppDispatch, useAppSelector} from "common/hook";
import AuthWrapper from "../../auth-wrapper/AuthWrapper";
import {fetchPayments} from "features/model/service/payments/payments";
import {fetchActs} from "features/model/service/payments/acts/fetchActs";



export const PaymentHistory = () => {
    const activeTabs = useAppSelector((state) => state.topTabs.activeTabs);
    const dispatch = useAppDispatch()

    useEffect(() => {
        dispatch(fetchPayments({}));
    }, [dispatch]);



    useEffect(() => {
        dispatch(fetchActs({}));
    }, [dispatch]);

    return (
        <AuthWrapper>
            <div className="app-main">
                <MainTop
                    title={'История платежей'}
                    payment={true}
                    tabs={false}
                    setting={false}
                    link={'/'}
                    icons={<BackIcon/>}/>
                {activeTabs.includes(0) && <PaymentTable />}
                {activeTabs.includes(1) && <ActsTable />}
            </div>
        </AuthWrapper>
    );
};

